import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "btn-area mb-4 d-flex justify-center"
}
const _hoisted_2 = {
  class: "ml-3",
  style: {"width":"15%"}
}


import i18n from "@/lang/i18n";
import { OUTPUT_PDF_TYPE_TEMPERATURE_GRAPH, OUTPUT_PDF_TYPE_TEMPERATURE_LIST } from "@/services/consts";
import UpsertCsvButtons from "@/components/Common/UpsertCsvButtons.vue";
import { computed } from 'vue'

const IMPORT_TYPE = "App\\Services\\Csv\\Upserts\\Imports\\SensorService";
const EXPORT_TYPE = "App\\Services\\Csv\\Upserts\\Exports\\SensorService";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreatePdfButton',
  props: {
    pdfBtnShoweableState: { type: Boolean },
    pdfGraphLoading: { type: Boolean },
    pdfListLoading: { type: Boolean },
    isManagementOffice: { type: Boolean },
    chartDetails: {},
    fetchData: { type: Function },
    authorities: {}
  },
  emits: ['downloadPdf'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

const isDisabledCsvUpsertBtn = computed(() => {
  if (!props.chartDetails.start_date_time || !props.chartDetails.end_date_time) {
    return true;
  }
  const start = new Date(props.chartDetails.start_date_time);
  const end = new Date(props.chartDetails.end_date_time);
  const diff = end.getTime() - start.getTime();
  return diff > 24 * 60 * 60 * 1000; // 1day by milliseconds
});

function downloadPdf(type: string) {
  emits('downloadPdf', type);
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (props.pdfBtnShoweableState)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_btn, {
          class: "exec-btn mt-0 ml-4",
          loading: props.pdfGraphLoading,
          disabled: props.pdfListLoading,
          style: _normalizeStyle({
        backgroundColor: props.pdfListLoading ? '#B3B8BB' : '',
      }),
          width: "15%",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadPdf(_unref(OUTPUT_PDF_TYPE_TEMPERATURE_GRAPH))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.temperatureSensors.charts.button.pdfGraph')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "style"]),
        _createVNode(_component_v_btn, {
          class: "exec-btn mt-0 ml-4",
          loading: props.pdfListLoading,
          disabled: props.pdfGraphLoading,
          style: _normalizeStyle({
        backgroundColor: props.pdfGraphLoading ? '#B3B8BB' : '',
      }),
          width: "15%",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (downloadPdf(_unref(OUTPUT_PDF_TYPE_TEMPERATURE_LIST))))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.temperatureSensors.charts.button.pdfList')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled", "style"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(UpsertCsvButtons, {
            title: _unref(i18n).global.t('pages.common.button.csvUpsert'),
            importTitle: _unref(i18n).global.t('pages.temperatureSensors.csvImportTitle'),
            importType: IMPORT_TYPE,
            exportType: EXPORT_TYPE,
            filterItems: props.chartDetails,
            authorities: {
          csvImport: props.authorities.import,
          csvExport: props.authorities.export
        },
            isDisabled: isDisabledCsvUpsertBtn.value,
            getList: props.fetchData,
            elementId: "sensor-upsert",
            btnClass: "exec-btn mt-0 ml-1 w-100",
            dropDownStyle: "width: 100%;"
          }, null, 8, ["title", "importTitle", "filterItems", "authorities", "isDisabled", "getList"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})